import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { HomeIcon } from 'components/icons/HomeIcon';
import { ChevronUpIcon } from 'components/icons/ChevronUpIcon';
import { DiscoverIcon } from 'components/icons/DiscoverIcon';
import { ListViewIcon } from 'components/icons/ListViewIcon';
import { css, cx } from 'linaria';
import { CollectionsIcon } from 'components/icons/CollectionsIcon';
import { useInView } from 'react-intersection-observer';
import { FiltersSideNav } from './filters';
import { AccountSideNav } from './account';
import { BookmarkIcon } from './bookmark-icon';
export const sideNavWrapper = "s3icf2j";
export const sideNavHeader = "s1jxyudr";
export const sideNavItem = "sv813dg";
export function SideNav({
  type,
  subset,
  tag,
  pinned,
  isDisabled,
  newSaveCount,
  trackMenuClick
}) {
  const {
    t
  } = useTranslation();
  const [ref, inView] = useInView({
    threshold: 0.5
  });

  const subActive = (active, isTag) => {
    const isActive = tag ? active === tag : active === subset;
    const activeClass = isActive ? 'active' : '';
    const tagClass = isTag ? 'tag-class' : '';
    return `${sideNavItem} ${activeClass} ${tagClass}`;
  };

  const scrollToTop = () => window.scroll({
    top: 0,
    left: 0
  });

  const wrapperClass = cx(sideNavWrapper, 'side-nav', isDisabled && 'disabled');

  const clickEvent = e => trackMenuClick(e.target.textContent);

  const navTypes = {
    'my-list': FiltersSideNav,
    account: AccountSideNav
  };
  const SubNav = navTypes[type];
  return <div className={wrapperClass} data-cy="side-nav">
      <nav role="navigation">
        <Link href="/home?src=sidebar">
          <button ref={ref} // when ref offscreen, show "Return to top" button
        className={subActive('home')} onClick={clickEvent} data-cy="side-nav-home">
            <HomeIcon className="side-nav-icon" /> {t('nav:home', 'Home')}
          </button>
        </Link>
        <Link href="/my-list?src=sidebar">
          <button className={subActive('unread')} onClick={clickEvent} data-cy="side-nav-mylist">
            <ListViewIcon className="side-nav-icon" /> {t('nav:my-list', 'My List')}
            <BookmarkIcon newSaveCount={newSaveCount} />
          </button>
        </Link>
        <Link href="/explore?src=sidebar">
          <button className={subActive('discover')} onClick={clickEvent} data-cy="side-nav-discover">
            <DiscoverIcon className="side-nav-icon" /> {t('nav:discover', 'Discover')}
          </button>
        </Link>
        <Link href="/collections?src=sidebar">
          <button className={subActive('collections')} onClick={clickEvent} ref={ref} data-cy="side-nav-collections">
            <CollectionsIcon className="side-nav-icon" /> {t('nav:collections', 'Collections')}
          </button>
        </Link>
        {SubNav ? <SubNav subActive={subActive} pinned={pinned} clickEvent={clickEvent} /> : null}
      </nav>
      <div className="bottom-nav">
        <button onClick={scrollToTop} aria-label={t('nav:return-to-top', 'Return to top')} className={!inView ? 'visible' : 'hidden'} data-cy="side-nav-scroll-to-top">
          <ChevronUpIcon />
        </button>
      </div>
    </div>;
}

require("./side-nav.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./side-nav.js");